.checkbox-button-bar__container {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-button-bar__container--label-left {
  align-items: baseline;
  flex-direction: row;
  gap: 1rem;
}

.checkbox-button-bar__container--label-top {
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-button-bar__row-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-button-bar__row-container--segmented {
  flex-direction: row;
}

.checkbox-button-bar__row {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-700);
  border-radius: 0.5rem;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
  padding: 0.25rem;
}

.checkbox-button-bar__row--not-valid {
  border-color: var(--color-red-600);
}

.checkbox-button-bar__sub-text {
  color: var(--color-grey-700);
  font-size: var(--font-size-text-non-essential);
}
